﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Abonnement",
  "change": "Ändern",
  "currency": "USD",
  "save": "Speichern",
  "save17Percent": "<strong>Mit Produktvariante „Jährlich“ {{percent}} %</strong> sparen",
  "save17PercentNoBold": "{{percent}} % sparen",
  "yearly": "Jährlich",
  "monthly": "Monatlich",
  "Lifetime": "Lebenszeit",
  "PerMonth": "Pro Monat",
  "PerYear": "Pro Jahr",
  "Free": "Kostenlos",
  "optional": "optional",
  "trialLengthTrial": "<0>{{ trialLength }}</0>-tägiger Test",
  "viewAllPlans": "Alle Produktvarianten anzeigen",
  "myBoardmaker": "My Boardmaker",
  "canada": "Kanada",
  "unitedStates": "Vereinigte Staaten von Amerika",
  "oneMomentPlease": "Einen Moment bitte ...",
  "software": "Software",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Vollständig",
  "loadingRegions": "Verfügbare Regionen werden geladen",
  "loadingPartners": "Verfügbare Partner werden geladen",
  "supportedPeripherals": "Unterstützte Peripheriegeräte",
  "pleaseWait": "Bitte warten...",
  "minimum": "Minimum",
  "recommended": "Empfohlen",
  "browser": "Browser",
  "tobiiDynavoxEyeTrackers": "Eyetracker von Tobii Dynavox",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "brauche Hilfe bei Auswahl",
  "or": "oder",
  "advantages": "Vorteile",
  "visitPartnerSite": "Partner-Website besuchen",
  "recentOrders": "Aktuelle Bestellungen",
  "current": "aktuell",
  "orLater": "oder später",
  "customerSupport": "Kundensupport",
  "proratedAmount": "Anteiliger Betrag",
  "community": {
    "community": "Community",
    "getStartedNow": "Jetzt loslegen!"
  },
  "personal": "Einzellizenz",
  "professional": "Expertenlizenz",
  "planCard": {
    "noCCRequired": "Keine Kreditkarte erforderlich",
    "cCOnly": "Nur Kreditkarte",
    "cCOrPO": "Kreditkarte oder Kaufauftrag",
    "myPlan": "Mein Produkt",
    "currentPlan": "Derzeitiges Produkt",
    "downgradeNotice": "Die Änderungen treten in Kraft, wenn das derzeitige Produkt ausläuft.",
    "upgradeNotice": "Die Änderungen treten sofort in Kraft."
  },
  "selectedPlanSummary": {
    "summary": "Zusammenfassung",
    "change": "$t(change)",
    "subtotal": "Zwischensumme"
  },
  "action": {
    "joinToday": "Sofort dabei sein",
    "finish": "Fertig stellen",
    "subscribe": "Abonnieren",
    "resubscribe": "Erneut abonnieren",
    "requestAQuote": "Angebot anfragen",
    "try": "Testen",
    "startTrial": "Test starten",
    "buyNow": "Jetzt kaufen",
    "tryIt": "Testen Sie es",
    "tryItFree": "Kostenlos 30 Tage lang testen!",
    "free": "kostenlos",
    "getStarted": "Beginnen",
    "forTrialDays": "für <1>{{trialLength}}</1> Tage",
    "comparePlans": "Produkte vergleichen",
    "hideComparisons": "Produktvergleich schließen",
    "learnMore": "Mehr erfahren",
    "start": "Start",
    "next": "Weiter",
    "edit": "Bearbeiten",
    "cancel": "Abbrechen",
    "imTaxExempt": "Steuerbefreiung",
    "submit": "Einsenden",
    "print": "Drucken",
    "backToPaymentDetails": "Zurück zu Zahlungsdaten",
    "close": "Schließen",
    "back": "Zurück",
    "continue": "Fortsetzen",
    "uploading": "Lade hoch",
    "delete": "Löschen",
    "update": "Aktualisieren",
    "generatingInvoice": "Rechnung wird erstellt",
    "proceed": "Fortfahren",
    "modify": "Ändern",
    "yes": "Ja",
    "signUp": "Registrieren",
    "downloads": "Downloads"
  },
  "status": {
    "loading": "Wird geladen ...",
    "creatingAccount": "Konto wird erstellt ...",
    "submitting": "Wird übermittelt ...",
    "submittingPayment": "Zahlung wird übermittelt ...",
    "submittingRequest": "Anfrage wird übermittelt ..."
  },
  "planComparison": {
    "label": "Welche Funktionen sind in den einzelnen Produktvarianten enthalten?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Funktionen im Vergleich",
    "subheader": "Die weltweit beliebteste Lösung zur Erstellung grenzenloser symbolbasierter Kommunikation und visueller Unterstützungen!"
  },
  "account": {
    "email": "E-Mail",
    "accountFoundTitle": "Konto gefunden",
    "accountFoundMessage": "Eine Konto mit dieser E-Mail-Adresse existiert bereits. Möchten Sie sich mit diesem Konto anmelden oder mit einer anderen E-Mail-Adresse ein neues Konto erstellen?",
    "signedOutElsewhereTitle": "Sie wurden abgemeldet",
    "signedOutElsewhereMessage": "Sie wurden in einem anderen Tab abgemeldet. Melden Sie sich erneut an, um fortzufahren, oder schließen Sie dies, um ohne Konto weiter zu surfen.",
    "signedOutElsewhereDismiss": "Weiter surfen",
    "federatedEmailTitle": "Organisations-E-Mail erkannt",
    "federatedEmailMessage": "Diese E-Mail-Adresse verwendet die Anmeldung Ihrer Organisation. Melden Sie sich an, um über Ihre Organisation auf Boardmaker zuzugreifen, oder verwenden Sie eine andere E-Mail-Adresse, um ein neues Konto zu erstellen.",
    "federatedEmailUseDifferent": "Andere E-Mail-Adresse verwenden",
    "logIn": "Anmelden",
    "logOut": "Abmelden",
    "loggingIn": "Anmeldung läuft ...",
    "loggingOut": "Abmeldung läuft ...",
    "verifying": "Überprüfung läuft ...",
    "loggingInMessage": "Sie werden angemeldet ...",
    "createAccount": "Konto erstellen",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "Sie haben bereits ein ",
    "login2": "Tobii Dynavox",
    "login3": "-Konto.",
    "loginPrompt": "Sie haben bereits ein <1>Tobii Dynavox-Konto</1>? <3>Anmelden</3>",
    "cancelSubscription": "Abonnement kündigen",
    "areYouSure": "Produkt wirklich auswählen? Wenn du fortfährst, geschieht Folgendes:",
    "cancelSubscriptionProcess": "Den Abonniervorgang abbrechen (Ihre bisherigen Fortschritte gehen verloren)",
    "changeToCommunityPlan": "Mit dem Konto zu einem Community-Tarif wechseln",
    "onceYouveCompletedYourProfile": "Wenn Sie Ihr Profil vervollständigt haben und beschließen, zu einem höheren Tarif zu wechseln, haben Sie über den Abschnitt „Mein Konto“ jederzeit die Möglichkeit dazu.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Benutzerdaten werden abgerufen"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Tragen Sie unten die entsprechenden Daten ein. Ein Kundenbetreuer wird sich in Kürze mit Ihnen in Verbindung setzen.",
    "fillOutDetailsBelowLicense": "Tragen Sie unten die entsprechenden Daten ein. Ein Fachhändler wird sich in Kürze mit Ihnen in Verbindung setzen."
  },
  "forms": {
    "confirmEmail": "E-Mail bestätigen",
    "billingDetails": "Rechnungsdaten",
    "paymentType": "Zahlungsart",
    "creditCardType": "Zahlungsart",
    "creditCard": "Kreditkarte",
    "purchaseOrder": "Kaufauftrag",
    "cardNumber": "Kartennummer",
    "expirationDate": "Ablaufdatum",
    "cardholderName": "Name des Karteninhabers",
    "cardSecurityCode": "Sicherheitscode der Karte",
    "securityCode": "Sicherheitscode",
    "organizationName": "Name der Organisation",
    "accountsPayableEmail": "E-Mail-Adresse für Rechnung",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "addressLine": "Adresszeile 1",
    "addressLine2": "Adresszeile 2",
    "country": "Land",
    "language": "Sprache",
    "city": "Stadt",
    "stateProvinceRegion": "Staat / Provinz / Region",
    "zipPostalCode": "Postleitzahl",
    "month": "Monat",
    "year": "Jahr",
    "optional": "optional",
    "username": "Benutzername",
    "name": "Name",
    "phoneNumber": "Telefonnummer",
    "phone": "Telefon",
    "email": "E-Mail",
    "url": "URL",
    "selectYourCountry": "Land auswählen",
    "selectYourState": "Bundesland auswählen",
    "selectYourProvinceTerritory": "Region oder Landkreis auswählen",
    "selectYourTerm": "Laufzeit auswählen",
    "1year": "1 Jahr",
    "2years": "2 Jahre",
    "3years": "3 Jahre",
    "4years": "4 Jahre",
    "5years": "5 Jahre",
    "instructorLogins": "Anzahl der Zugänge für Lehrer",
    "studentLogins": "Anzahl der Zugänge für Lernende",
    "term": "Zeitraum",
    "tradeIn": "Sie können einen Tauschrabatt in Anspruch nehmen?",
    "legacyVersions": "Haben Sie alte Versionen von Boardmaker, die sie gegen einen Rabatt auf myBoardmaker eintauschen möchten?",
    "selectAResponse": "Antwort auswählen",
    "yes": "Ja",
    "no": "Nein",
    "pleaseEnterYourName": "Geben Sie Ihren Namen genauso ein, wie er auf der Karte geschrieben ist.",
    "needHelpFindingSecurityCode": "Hilfe nötig, um den Sicherheitscode der Karte zu finden",
    "notSure": "Nicht sicher",
    "password": "Passwort",
    "confirmPassword": "Passwort bestätigen",
    "additionalInformationOrQuestions": "Zusätzliche Informationen oder Fragen",
    "countryNotSupported": "---",
    "uploadDocument": "Dokument hochladen",
    "chooseFile": "Datei auswählen",
    "paymentMethod": "Zahlungsmethode",
    "purchaseOrdersAreOnlyProcessed": "Kaufaufträge werden erst bearbeitet, wenn die Bestellung übermittelt wird. Vorher können sie noch jederzeit geändert werden.",
    "PONumber": "Nummer des Kaufauftrags",
    "PONotes": "Anmerkungen der Organisation",
    "iVerifyThatImAuthorized": "Ich bestätige, dass ich zur Einsendung dieses Kaufauftrags berechtigt bin.",
    "submissionSuccessful": "Einsendung erfolgreich!",
    "thankYourForYourRequest": "Vielen Dank für Ihre Anfrage! Ein Kundenbetreuer wird sich in Kürze mit Ihnen in Verbindung setzen.",
    "ccExpDateFormat": "MM/JJJJ",
    "numberOfLicenses": "Anzahl der Lizenzen"
  },
  "validation": {
    "required": "Erforderlich",
    "invalidEmail": "Ungültige E-Mail-Adresse",
    "emailsMustMatch": "Die E-Mail-Adressen müssen übereinstimmen.",
    "passwordsMustMatch": "Die Passwörter müssen übereinstimmen.",
    "errorOccurred": "Bei der Übermittlung des Formulars ist ein Fehler aufgetreten.",
    "tryAgain": "Versuchen Sie es erneut. Wenden Sie sich an den Support, wenn das Problem weiterhin besteht.",
    "errorOccurredPDF": "Beim Laden der PDF-Rechnung ist ein Fehler aufgetreten.",
    "password": {
      "minLength": "Das Passwort muss aus mindestens 8 Zeichen bestehen",
      "tooShort": "Zu kurz",
      "checking": "Überprüfung läuft ..."
    },
    "invalidCardNumber": "Ungültige Kartennummer",
    "invalidCardType": "Ungültiger Kartentyp",
    "invalidExpirationDate": "Ungültiges Ablaufdatum",
    "invalidSecurityCode": "Ungültiger Sicherheitscode",
    "securityCodeNumericWarning": "Sicherheitscode darf nur Zahlen enthalten",
    "invalidUsernameWarning": "Ungültiger Benutzername Darf nur Buchstaben und Zahlen enthalten.",
    "usernameMaxLengthWarning": "Benutzername darf nicht länger als 60 Zeichen sein",
    "badZip": "Die eingegebene Postleitzahl ist für das ausgewählte Bundesland nicht gültig.",
    "badPostalCode": "Die eingegebene Postleitzahl ist für die ausgewählte Region bzw. den ausgewählten Landkreis nicht gültig.",
    "canadianAddressNeedsCad": "Kanadische Rechnungsadressen werden in kanadischen Dollar abgerechnet. Um fortzufahren, wählen Sie oben auf der Seite die Flagge und dann Kanada aus.",
    "USZipCode": "Eingabe einer US-amerikanischen Postleitzahl erforderlich",
    "CAZipCode": "Eingabe einer kanadischen Postleitzahl erforderlich."
  },
  "invoice": {
    "communityHeader": "Keine Kreditkarte. Einfach kostenloser Zugang zur myBoardmaker Community. Wenn Sie sich für den Wechsel zu einem kostenpflichtigen Abonnement entscheiden, können Sie einfach Ihre Daten und Fortschritte behalten. Worauf warten Sie?",
    "trialHeader": "Keine Einschränkungen. Keine Kreditkarte. Wenn Sie sich entscheiden, den Test in ein kostenpflichtiges Abonnement umzuwandeln, können Sie einfach Ihre Daten und Fortschritte behalten. Worauf warten Sie?",
    "plan": "Produktvariante",
    "term": "Zeitraum",
    "price": "Preis",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Zahlungsdetails",
    "endingWith": "Endet mit dem",
    "expires": "Läuft ab am",
    "orderSummary": "Bestellübersicht",
    "orderDate": "Bestelldatum",
    "orderNumber": "Bestellnummer",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Steuern",
    "total": "Gesamt",
    "aConfirmationEmail": "Eine E-Mail mit einer Auftragsbestätigung wurde an folgende Adresse gesendet:",
    "printOrderSummary": "Bestellübersicht drucken",
    "recurringPaymentDisclaimer": "Ihre Bestellung umfasst eine <strong>regelmäßige Zahlung</strong> in Höhe von <3>{{amount}}</3>, die <5>{{date, LL}}</5> erneuert.",
    "firstPaymentDisclaimer": "Wir berechnen Ihnen <strong>{{amount}}</strong> am <strong>{{date}}</strong>, wenn Ihr neues Abonnement beginnt.",
    "PODisclaimer": "Ihr Abonnement ist jetzt aktiv und kann verwendet werden. Wenn keine Serviceunterbrechungen auftreten sollen, müssen wir Ihre Zahlung innerhalb von <strong>30 Tagen</strong> erhalten. Wenn wir die Zahlung nicht bis zum <4>{{date, LL}}</4> erhalten, wird Ihr Konto in ein kostenloses Community-Konto umgewandelt, bis der Fehlbetrag beglichen ist.",
    "purchaseOrderNumber": "Nummer des Kaufauftrags",
    "orgNotes": "Anmerkungen der Organisation",
    "pleaseSendACopyOfYourInvoice": "Senden Sie die Zahlung und eine Rechnungskopie an:",
    "ifYourPurchaseOrdersReady": "Wenn Ihr Kaufauftrag fertig ist, können Sie ihn jetzt hochladen.",
    "supportedFileTypes": "Unterstützte Dateitypen: .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Wenn es so weit ist, senden wir eine E-Mail an <1>{{email}}</1>, um Sie daran zu erinnern, dass die nächste Zahlung fällig ist.",
    "uploadSuccessful": "Der Upload war erfolgreich!",
    "yourAccountWillContinue": "Vielen Dank für Ihre Bestellung. Bei Abonnementverlängerungen kann die Bearbeitung Ihrer Bestellung bis zu 14 Tage dauern. Nach Abschluss der Bearbeitung werden Sie eine E-Mail mit einer Bestätigung und Ihrer Rechnung erhalten.",
    "billing": "Rechnungsadresse",
    "payment": "Zahlungsmethode",
    "ifYourPurchaseOrderIsReady": "Wenn Ihr Kaufauftrag fertig ist, können Sie ihn jetzt hochladen.",
    "PODisclaimer1": "Ihr Abonnement ist jetzt aktiv und kann verwendet werden.",
    "PODisclaimer2": "Die Zahlung muss innerhalb von 30 Tagen eingehen, oder Ihr Konto wird automatisch in ein kostenloses Community-Konto umgewandelt.",
    "POStartsLaterDisclaimer": "Wir senden Ihnen Ihre Rechnung am <strong>{{date}}</strong>, wenn Ihr neues Abonnement beginnt. Die Zahlung ist innerhalb von 30 Tagen ab diesem Datum fällig."
  },
  "legal": {
    "privacyPolicy": "Datenschutzrichtlinie",
    "studentPolicy": "Richtlinie zu Schülerdaten",
    "termsAndConditions": "Geschäftsbedingungen",
    "termsOfService": "Dienstleistungsbedingungen",
    "tdTermsAndConditions": "Ich stimme den <1>$t(legal.termsAndConditions) von Tobii Dynavox zu</1>",
    "contactUs": "Kontaktiere uns"
  },
  "errors": {
    "error": "Fehler",
    "loadingPlans": "Produktvarianten werden geladen",
    "sorry": "Entschuldigung ... Es liegt nicht an Ihnen, sondern an uns.",
    "somethingWentWrong": "Bei uns ist etwas schiefgegangen. Wir haben diesen Fehler festgestellt. Bitte <1>{{link}}</1>, falls das Problem noch einmal auftauchen sollte.",
    "tryGoingBack": "Gehen Sie zur vorherigen Seite oder <1>{{link}}</1>",
    "downloadList": "Die Liste mit den Downloads konnte nicht geladen werden."
  },
  "404": {
    "sorry": "Entschuldigung ... Wir konnten die Seite nicht finden.",
    "oldLink": "Vielleicht handelt es sich um einen alten Link, oder die Adresse hat sich geändert.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Starten Sie jetzt Ihren kostenlosen Test!",
    "startYourFreeTrial": "Kostenlosen Test starten",
    "todayWhichIncludesAccessForThirtyDays": " und von heute an 30 Tage lang Zugang erhalten!"
  },
  "navigation": {
    "bmoRedirect": "Sie werden zu myBoardmaker umgeleitet ..."
  },
  "expired": {
    "expiredTrialText": "Wir hoffen, die kostenlose 30-tägige Vorschau hat Ihnen gefallen. Ihre Testvariante wurde in ein kostenloses Community-Produkt umgewandelt und all Ihre Daten und Fortschritte wurden gespeichert. Wenn Sie die Premium-Funktionen nutzen möchten, die Ihnen während des Tests zur Verfügung standen, entscheiden Sie sich einfach für ein Monats- oder Jahresabonnement.",
    "dataAndProgress": "* Sie erhalten nur mit einem vollständigen kostenpflichtigen Abonnement Zugriff auf die in den Premium-Funktionen enthaltenen Daten und Fortschritte."
  },
  "currencySelector": {
    "header": "Land und Sprache auswählen",
    "disclaimer": {
      "USD": "Wenn Ihr Land nicht in der Liste steht, wählen Sie die USA aus."
    }
  },
  "taxExempt": {
    "us&ca": "Nur USA und Kanada",
    "taxExemptionProgram": "Mit diesem Formular können Sie Ihre Dokumente für die Steuerbefreiung einreichen. Wir bestätigen Ihren Steuerbefreiungsstatus innerhalb von 3 Geschäftstagen per E-Mail. Sobald Sie eine Bestätigungs-E-Mail erhalten haben, können Sie eine steuerfreie Bestellung aufgeben. Wenn Sie die Bestellung aufgeben, bevor Sie die Bestätigungs-E-Mail erhalten, werden Ihnen nicht erstattungsfähige Steuern in Rechnung gestellt.",
    "taxExemptionProgramExisting": "Mit diesem Formular können Sie Ihre Dokumente für die Steuerbefreiung einreichen. Wir bestätigen Ihren Steuerbefreiungsstatus innerhalb von 3 Geschäftstagen per E-Mail. Wenn Sie per E-Mail eine solche Genehmigung erhalten, werden in Zukunft auf ihre Käufe und Abonnementzahlungen keine Steuern erhoben. Wenn Sie Steuern auf Käufe gezahlt haben, die vor Erhalt der Steuerbefreiungsbestätigung getätigt wurden, werden diese nicht erstattet.",
    "yourSubmissionWasSuccessfulNew": "Ihre Einsendung war erfolgreich. Unsere Mitarbeiter werden Ihre Dokumente prüfen. Sie erhalten innerhalb der nächsten 3 Geschäftstage per E-Mail eine Benachrichtigung, dass Ihr Antrag bearbeitet wurde. Wenn die Zustimmung erteilt wird, können Sie Ihre Bestellung steuerfrei aufgeben. Bis dahin haben wir für Sie ein Community-Konto erstellt, damit Sie sich schon einmal mit all den Vorteilen vertraut machen können, die myBoardmaker zu bieten hat.",
    "yourSubmissionWasSuccessfulExisting": "Ihre Einsendung war erfolgreich. Unsere Mitarbeiter werden Ihre Dokumente prüfen. Sie erhalten innerhalb der nächsten 3 Geschäftstage per E-Mail eine Benachrichtigung, dass Ihr Antrag bearbeitet wurde. Wenn die Zustimmung erteilt wird, erheben wir auf Ihre nächste Zahlung keine Steuern."
  },
  "modify": {
    "contactCustomerSupport": "Wenn Sie Ihr Abonnement ändern möchten, wenden Sie sich an <1>{{supportLink}}</1>",
    "billingDetails": "Rechnungsdaten ändern",
    "paymentModalHeader": "Die Aktualisierung war erfolgreich!",
    "paymentModalBody": "Ihre Änderungen werden im nächsten Abrechnungszeitraum berücksichtigt.",
    "thankYou": "Vielen Dank für Ihre Zahlung!",
    "daysRemaining": "verbleibende Tage",
    "dueDisclaimer": "Wenn wir die Zahlung nicht innerhalb von 30 Tagen ab dem Verlängerungsdatum erhalten, wird Ihr Konto automatisch in ein kostenloses Community-Konto umgewandelt, bis der Fehlbetrag beglichen ist.",
    "lateDisclaimer": "Um eine Unterbrechung des Abonnements zu vermeiden, begleichen Sie den Fehlbetrag bitte vollständig. Wenn wir die Zahlung nicht erhalten, wird Ihr Konto automatisch in ein kostenloses Community-Konto umgewandelt, bis der Fehlbetrag beglichen ist.",
    "nextPaymentDueIn": "Nächste Zahlung fällig in",
    "days": "Tagen",
    "paymentIs": "Die Zahlung ist",
    "daysPastDue": "Tage überfällig",
    "recurringPaymentDisclaimer": "Ihr(e) <1>planOrOrder</1> umfasst eine <strong>regelmäßige Zahlung</strong> in Höhe von <4>{{amount}}</4>, die <7>{{date, LL}}</7> erneuert.",
    "recurringPaymentDisclaimerNoPrice": "Ihr Produkt beinhaltet eine <strong>regelmäßige Zahlung</strong>, die am <3>{{date, LL}}</3> wieder fällig ist.",
    "pastDueDisclaimer": "Sie können uns den Kaufauftrag auf eine der im folgenden beschriebenen Weisen übermitteln. Wenn Sie Ihr Abonnement wieder aktivieren möchten, wenden Sie sich an den Kundensupport.",
    "yourAccountHasBeenConverted": "Ihr kostenpflichtiges Konto wird in ein kostenloses Community-Konto umgewandelt.",
    "balanceDueIn": "Fehlbetrag fällig in",
    "subscriptionExpiresIn": "Abonnement läuft ab in",
    "paymentPastDue": "Zahlung überfällig",
    "autoRenewal": "Automatische Verlängerung",
    "turnAutoRenewOff": {
      "header": "Automatische Verlängerung des Abonnements deaktivieren",
      "areYouSure": "Automatische Verlängerung wirklich deaktivieren? Wenn du fortfährst, geschieht Folgendes:",
      "points": [
        "Ihr kostenpflichtiges Abonnement wird zum Ende des derzeitigen Abrechnungszeitraums gekündigt.",
        "Ihr Konto wird zum Ende des derzeitigen Abrechnungszeitraums in ein kostenloses Community-Konto umgewandelt.",
        "Sie haben nach der Umwandlung Zugriff auf Ihre Inhalte und können jederzeit ein neues Abonnement abschließen, um die mit kostenpflichtigen Abonnements verbundenen Premium-Funktionen zu nutzen. ",
        "Wenn Sie es sich vor Ablauf des derzeitigen Abonnements anders überlegen, können Sie die automatische Verlängerung einfach wieder aktivieren."
      ],
      "footer": "Möchten Sie die automatische Verlängerung deaktivieren?"
    },
    "turnAutoRenewOn": {
      "header": "Automatische Verlängerung des Abonnements aktivieren",
      "areYouSure": "Automatische Verlängerung des Abonnements – Merkmale:",
      "points": [
        "Mit dieser Einstellung wird Ihr Abonnement nach Ablauf des derzeitigen Abrechnungszeitraums automatisch verlängert.",
        "Die Zahlung wird mit der hinterlegten Zahlungsmethode reibungslos abgewickelt.",
        "Wir senden Ihnen jedes Mal, wenn das Abonnnement verlängert wird, per E-Mail einen Beleg.",
        "Wie immer können Sie die Abonnementeinstellungen jederzeit unter „Meine Produktdetails“ ändern.",
        "Sie haben es sich anders überlegt? Wenn Sie die automatische Verlängerung vor Ablauf des letzten Tages Ihres derzeitigen Abonnements deaktivieren, wird sie Ihnen nicht in Rechnung gestellt."
      ],
      "footer": "Möchten Sie die automatische Verlängerung aktivieren?"
    },
    "on": "Ein",
    "off": "Aus",
    "pending": "ausstehend",
    "plan": "Produktvariante",
    "term": "Zeitraum",
    "effective": "Wirksam",
    "subscription": "Abonnement",
    "downgradeWarning": {
      "title": "Abonnement herunterstufen",
      "prompt": "Produkt wirklich auswählen? Wenn du fortfährst, geschieht Folgendes:",
      "planChange": "Produkt am Ende des derzeitigen Abrechnungszeitraums von Expertenlizenz zu Einzellizenz herunterstufen",
      "termChange": "Produkt am Ende des derzeitigen Abrechnungszeitraums von „Jährlich“ zu „Monatlich“ herunterstufen",
      "changeNote": "Ihre Änderungen werden im nächsten Abrechnungszeitraum berücksichtigt.",
      "termChangeMultiToYearly": "Produkt am Ende des derzeitigen Abrechnungszeitraums von einer mehrjährigen Variante zu „Jährlich“ herunterstufen",
      "termChangeMultiToMonthly": "Produkt am Ende des derzeitigen Abrechnungszeitraums von einer mehrjährigen Variante zu „Monatlich“ herunterstufen"
    },
    "futureAmendmentThankYou": "Diese Änderungen werden am Ende des derzeitigen Abrechnungszeitraums wirksam. Die Rechnung ist verfügbar, sobald diese Änderungen auf Ihr Konto angewendet wurden. Wenn Sie eine ausstehende Änderung stornieren möchten, rufen Sie den <1>Kundendienst</1> an.",
    "futureAmendmentDisclaimer": "Ihr derzeitiges Produkt <1>{{planName}}</1> läuft am <3>{{startEndDate}}</3> aus. Ihr neues Produkt <5>{{selectedPlanName}}</5> startet am <7>{{startEndDate}}</7> und wird am <9>{{term}}</9> automatisch verlängert.",
    "modificationPending": "Ausstehende Produktänderungen",
    "paymentDeclined": "Die Transaktion zur Verlängerung Ihres Abonnements wurde zurückgewiesen. Ändern Sie bis zum <1>{{date}}</1> Ihre Zahlungsmethode. Sonst wird Ihr Abonnement gekündigt.",
    "continueSubscription": "Ihr Abonnement endet am <1>{{ date1 }}</1>. Wenn Sie Ihr Abonnement noch einmal um {{term}}, verlängern möchten, aktivieren Sie bis zum <5>{{ date2 }}</5> die automatische Verlängerung. Wir werden Ihre Zahlung am darauffolgenden Tag bearbeiten.",
    "discontinuedRatePlan": "Ihre derzeitige Produktvariante ist nicht mehr verfügbar. Wählen Sie eine andere Option.",
    "cancelYourSubscription": "Wenn Sie Ihr Abonnement kündigen und sich die Kosten erstatten lassen möchten, wenden Sie sich zuvor an <1>{{supportLink}}</1> <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Abonnement ändern",
    "cancelCardText": "Sie können Ihr Abonnement jederzeit kündigen. Wir würden uns aber freuen, wenn Sie bleiben.",
    "cancelConfirmTitle": "Möchten Sie Ihr Abonnement wirklich kündigen?",
    "cancelConfirmIntro": "Ihr derzeitiges Produkt bleibt bis zum <strong>{{date}}</strong> aktiv. Nach Ablauf Ihres Produkts gilt Folgendes:",
    "cancelConsequences": [
      "Sie verlieren den Zugriff auf Premium-Funktionen.",
      "Sie verpassen exklusive Vorteile, die Ihr Abonnement bietet.",
      "Die Vorteile Ihres Abonnements enden, wenn Ihr derzeitiges Produkt abläuft."
    ],
    "keepSubscription": "Abonnement behalten",
    "confirmCancel": "Nein, ich möchte kündigen",
    "cancelledTitle": "Ihr Abonnement wurde gekündigt!",
    "cancelledBody": "Ihr Abonnement wurde gekündigt. Nach dem {{date}} haben Sie keinen Zugriff mehr auf Ihr Premium-Konto.",
    "cancelledFarewell": "Schade, dass Sie gehen! Sie sind jederzeit wieder willkommen.",
    "done": "Fertig",
    "cancelledNotice": "Ihr aktuelles <strong>{{planName}}</strong>-Abonnement läuft am <strong>{{date}}</strong> ab. Erneuern Sie Ihr Abonnement, um weiterhin unsere Premium-Funktionen zu nutzen.",
    "resubscribedNotice": "Ihr neues <strong>{{planName}}</strong>-Abonnement beginnt am <strong>{{date}}</strong>, wenn Ihr aktuelles abläuft."
  },
  "tdAccount": {
    "title": "Tobii Dynavox-Konto",
    "header": "Was ist ein Tobii Dynavox-Konto mit Einmalanmeldung (SSO)?",
    "body": "Ihr SSO-Konto bei Tobii Dynavox besteht aus einer E-Mail-Adresse und einem Passwort. So können Sie sich mit einem einzigen Konto bei all unseren Websites und Apps anmelden. SSO bietet nicht nur verbesserte Sicherheitsfunktionen, sondern auch schnelleren und bequemeren Zugang zu all Ihren Serviceinhalten bei Tobii Dynavox.",
    "haveA": "Sie haben ein",
    "tobiiDynavoxAccount": "Tobii Dynavox-Konto?"
  },
  "redirectPageTitle": {
    "homePage": "Startseite",
    "profileCreation": "Profilerstellung"
  },
  "download": {
    "downloadBoardmaker": "Boardmaker herunterladen",
    "downloadBoardmakerStudentCenter": "Boardmaker Student Center herunterladen",
    "downloadOtherVersions": "Andere Versionen herunterladen",
    "downloadBoardmakerStudio": "Boardmaker Studio herunterladen",
    "licenseKey": "Lizenzschlüssel",
    "download": "Herunterladen",
    "licenseHelper": "Lizenzmanager",
    "discontinued": "Unterstützung am <1>{{discontinueDate}}</1> eingestellt. Siehe <3>Systemvoraussetzungen</3>.",
    "mainFeatures": "Wichtigste Funktionen",
    "compatibility": "Kompatibilität",
    "improvements": "Verbesserungen",
    "bugFixes": "Fehlerbehebungen",
    "version": "Version",
    "discontinuedSupport": "Support beendet",
    "releaseDate": "Veröffentlicht am  {{date}}",
    "discontinuedDate": "Vom Markt genommen {{date}}",
    "boardmakerSummary": "Über die Schaltfläche weiter unten können Sie die aktuelle Version von Boardmaker Editor herunterladen, um damit Aktivitäten zu erstellen und zu bearbeiten.  Das Installationsprogramm ist mit allen Kontotypen und allen unterstützten Sprachen kompatibel.",
    "studentCenterSummary": "Über die Schaltfläche weiter unten können Sie die aktuelle Version von Boardmaker Student Center herunterladen, um damit Boardmaker-Aktivitäten auszuführen. Das Installationsprogramm ist mit allen Kontotypen und allen unterstützten Sprachen kompatibel.",
    "boardmakerIntro": "Boardmaker 7 Editor on ensisijainen työkalu, jonka avulla opettajat, terapeutit ja vanhemmat voivat luoda, muokata ja jakaa Boardmaker-toimintoja.  Tue oppimista ja viestintää luokkahuoneessa, terapiahuoneessa tai kotona mukautettavan materiaalin avulla.",
"studentCenterIntro": "In Verbindung mit speziellen Boardmaker 7 Abonnements können Lehrer*innen ihren Schüler*innen über die Boardmaker 7 Student Center App Aktivitäten zuweisen und deren Fortschritt nachverfolgen.  Die Schüler*innen können mit dieser App ihre Aufgaben zu Hause oder in der Schule erledigen.",
"boardmakerStudioIntro": "Boardmaker Studio ermöglicht es Menschen, die Schüler*innen mit Behinderungen unterstützen, Aktivitäten zu erstellen und zu bearbeiten, die Schüler*innen beim Lernen und Kommunizieren mit Symbolen, Text sowie synthetischer und aufgenommener Sprache helfen.",
"mobilePlayerIntro": "In Verbindung mit speziellen myBoardmaker Abonnements können Lehrer*innen ihren Schüler*innen über die Boardmaker Student Center App Aktivitäten zuweisen und deren Fortschritt nachverfolgen.  Die Schüler*innen können mit dieser App ihre Aufgaben zu Hause oder in der Schule erledigen.",
    "communityStartHeader": [
      "Community-Zugang und Speicherplatz in Anspruch nehmen",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker ist für die Arbeit mit Boardmakeronline.com ausgelegt. Dort können Sie sichere Backups von Ihren persönlichen Boardmaker-Dateien erstellen und erhalten Zugang zu unserer weltweiten Community. Community-Mitglieder können mit anderen teilen, was sie erstellt haben, und nach neuen Boardmaker-Aktivitäten von anderen Benutzern suchen. Melden Sie sich für ein kostenloses Community-Konto an, und schon haben Sie Zugang!",
      0,
      0
    ],
    "latestMobile": "Die besten Ergebnisse erzielen Sie, wenn Sie die Software von einem Gerät herunterladen, das konform ist mit der <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "Systemanforderungen",
    "viewSystemRequirements": "Die Systemanforderungen finden Sie unter <1>{{guideLink}}</1>.",
    "onThisPage": "Auf dieser Seite",
    "communityStart": {
      "header": "Community-Zugang und Speicherplatz in Anspruch nehmen",
      "body": "Boardmaker ist für die Arbeit mit myboardmaker.com ausgelegt. Ihr kostenloses Boardmaker Community-Konto umfasst:",
      "pointOne": "Cloudspeicher – Boardmaker-Dateien sicher speichern und von überall aus darauf zugreifen!",
      "pointTwo": "Activities-to-Go – Druck- und einsatzbereite, nach Lernstufen und Themen geordnete Lerninhalte",
      "pointThree": "Zugang zur weltweiten Community – Teilen Sie mit anderen, was sie erstellt haben, und suchen Sie nach neuen Boardmaker-Aktivitäten von anderen Benutzern.",
      "footer": "Melden Sie sich für ein kostenloses Community-Konto an, und schon haben Sie Zugang!"
    },
    "BoardmakerCompatible": "Dieses Gerät ist nicht mit Boardmaker-Software kompatibel.",
    "BoardmakerStudentCenterCompatible": "Dieses Gerät ist nicht mit Boardmaker Student Center kompatibel.",
    "BoardmakerMobile": "Boardmaker-Anwendungen werden auf diesem Gerät nicht unterstützt."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "Abonnement",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "Lizenz",
      "tolicenseText": "Vollversion",
      "mainText": "Möchten Sie lieber <1>{{ toggleText }}</1> oder <3>{{ helpLink }}</3>?",
      "preferencedText": "Möchten Sie lieber "
    },
    "comparison": {
      "accessTo": "Zugriff auf folgende Optionen ...",
      "title": "Hilfe bei der Auswahl",
      "titleDescription": "Ein kurzer Überblick über die Unterschiede zwischen einem Boardmaker-Online-Abonnement und der Boardmaker-Software selbst.",
      "titles": {
        "investment": "Investition",
        "includedSoftware": "Im Produkt enthaltene Software",
        "softwareUpdates": "Software-Updates",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Cloudspeicher",
        "curriculum": "Lerninhalte",
        "studentManagement": "Schülerverwaltung"
      },
      "subscription": {
        "header": "Boardmaker-Online-Abonnement",
        "investment": "Niedrige Vorabkosten, Auswahl zwischen jährlicher und monatlicher Zahlung",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Inbegriffen (2–3 Mal jährlich)",
        "pcsSymbols": "Alle Symbole, einschließlich neuer Symbole alle 2 Wochen",
        "cloudStorage": [
          "Speicherplatz für Aktivitäten",
          "Speicherplatz für Medien"
        ],
        "curriculum": [
          "Boardmaker-Aktivitäten für unterwegs 10 Themen à 4 Lektionen",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": [
          "Aktivitäten zuweisen\u00B9",
          "Leistung nachverfolgen"
        ]
      },
      "license": {
        "header": "Nur Software",
        "investment": "Vollversion der Software",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Regelmäßige kostenpflichtige Upgrades (alle 2–3 Jahre)",
        "pcsSymbols": "Alle zum Veröffentlichungszeitpunkt der letzten Version verfügbaren Symbole (PCS-Abonnement in Kürze erhältlich)",
        "cloudStorage": "Speicher für Aktivitäten",
        "curriculum": "Boardmaker-Aktivitäten unterwegs 1 Thema mit 4 Lektionen",
        "studentManagement": "Keine"
      },
      "note": "In der Produktvariante mit Expertenlizenz können Benutzer Aufgaben verwalten und einzelnen Lernenden zuweisen.",
      "note2": "Zugriff nur mit Student Center Player möglich",
      "note3": "In der Produktvariante mit Expertenlizenz können Benutzer Aufgaben verwalten und einzelnen Lernenden zuweisen.",
      "localizationNoteOne": "Die Boardmaker 7-Apps sind sowohl für Abonnenten als auch für dauerhafte Benutzer (nur Software) in folgenden Sprachen erhältlich.",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Englisch (USA)",
        "Spanisch",
        "Deutsch",
        "Schwedisch",
        "Finnisch",
        "Russisch",
        "Dansk",
        "Norwegisch",
        "Französisch",
        "Italienisch",
        "Polnisch",
        "Portugiesisch"
      ],
      "localizationNoteTwo": "Die Lerninhalte und die Website myBoardmaker.com sind nur in Englisch verfügbar."
    }
  },
  "systemRequirements": "Systemvoraussetzungen",
  "releaseNotes": "Versionshinweise",
  "operatingSystem": {
    "title": "Betriebssystem",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (Mobilgerät)",
    "windows": "Windows",
    "unknown": "Unbekannt"
  },
  "perpetual": {
    "trial": {
      "intro": "Keine Kreditkarte. Keine Verpflichtung. Einfach <1>{{trialLength}}</1> aufeinanderfolgende Tage unbeschränkter Zugriff auf unsere neueste Boardmaker-Software. Wenn Sie die Software auf Ihren Computer herunterladen und installieren, können Sie von der Software aus einen <3>{{trialLength}}</3>-tägigen Aktivierungsschlüssel<5>*</5> anfordern.",
      "footnote": "<0>*</0>Der Test beginnt an dem Tag, an dem die Software aktiviert wird, und bleibt <2>{{trialLength}}</2> aufeinanderfolgende Tage lang aktiv.",
      "downloadFootnote": "<0>v{{version}}</0> enthält die neuesten Funktionen und Fehlerbehebungen. Siehe <2>Systemvoraussetzungen</2>."
    },
    "thankyou": {
      "intro": "Suchen Sie nach der E-Mail mit Ihrer Auftragsbestätigung. Sie enthält die Download-Links für Boardmaker und Ihren Aktivierungsschlüssel. Die Angaben finden Sie auch weiter unten. Laden Sie Boardmaker herunter und installieren Sie es auf Ihrem Computer. Anschließend können Sie die Software mit Ihrem Aktivierungsschlüssel aktivieren. Nach der Aktivierung erhalten Sie 1 Jahr lang kostenlose Updates. <1>Vergessen Sie nicht, den Aktivierungsschlüssel zur zukünftigen Verwendung zu speichern.</1>"
    },
    "latest": "Aktuell",
    "legacy": "Älter"
  },
  "countries": {
    "us": "Vereinigte Staaten von Amerika"
  },
  "currencyChange": {
    "header": "Währungsumstellung",
    "body": "Derzeit können Abonnements nicht mit der Währung des von Ihnen ausgewählten Landes gekauft werden. Im weiteren Verlauf wird Ihre Währung auf US-Dollars (USD) umgestellt."
  },
  "partner": {
    "body": "Der ausgewählte Partner (bzw. Supportanbieter) ist ihr primärer Kontakt für alle Fragen und technischen Probleme, die Ihr Produkt betreffen.",
    "contactUs": "Wenn nicht das richtige Land angegeben ist, ",
    "contactCustomerService": "wenden Sie sich an den Kundendienst."
  }
}
